import Dialog from '@mui/material/Dialog';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { Forbidden } from '@/components/organisms/Forbidden';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { Permission } from '@/types/permissions';

interface Props {
  readonly permission: Permission;
}

export const Authorized: React.FC<Props> = (props: Props): React.ReactNode => {
  const { permission } = props;

  const permissionsManager = usePermissionsManager();
  const navigate = useNavigate();

  const onClose = React.useCallback((): void => {
    navigate('/', { replace: true });
  }, [navigate]);

  if (permissionsManager.userIsAuthorizedTo(permission)) {
    return <Outlet />;
  }

  return (
    <>
      <Outlet />
      <Dialog open={true} onClose={onClose}>
        <Forbidden onClose={onClose} />
      </Dialog>
    </>
  );
};
